import { ANIMATION_CONFIG } from "./constants";

const { PULSE_DURATION_HOLD, PULSE_DURATION_IN, PULSE_DURATION_HOLD_BIG, PULSE_DURATION_OUT, PULSE_CYCLE_DURATION } =
  ANIMATION_CONFIG;

export function calculateEnterTimes(totalDuration: number, pulseStart: number): number[] {
  const holdDuration = totalDuration - pulseStart;
  const holdTime = holdDuration / totalDuration;
  const pulseTime = pulseStart / totalDuration;

  return [0, holdTime, pulseTime, 1];
}

export function calculatePulseLoopTimes(): number[] {
  const total = PULSE_CYCLE_DURATION;
  const t1 = PULSE_DURATION_HOLD / total;
  const t2 = (PULSE_DURATION_HOLD + PULSE_DURATION_IN) / total;
  const t3 = (PULSE_DURATION_HOLD + PULSE_DURATION_IN + PULSE_DURATION_HOLD_BIG) / total;
  const t4 = (PULSE_DURATION_HOLD + PULSE_DURATION_IN + PULSE_DURATION_HOLD_BIG + PULSE_DURATION_OUT) / total;

  return [0, t1, t2, t3, t4];
}

export function getExitTransition() {
  return {
    duration: ANIMATION_CONFIG.EXIT_DURATION,
    ease: "easeOut" as const,
  };
}

export function getFadeInTransition(delay: number) {
  return {
    delay,
    duration: ANIMATION_CONFIG.ENTER_DURATION,
    ease: "easeOut" as const,
  };
}
